import { render } from "./SearchInputHeader.vue?vue&type=template&id=31c0cc2a&ts=true"
import script from "./SearchInputHeader.vue?vue&type=script&lang=ts"
export * from "./SearchInputHeader.vue?vue&type=script&lang=ts"

import "./SearchInputHeader.vue?vue&type=style&index=0&id=31c0cc2a&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__